export default "__VITE_ASSET__Dds721Ed__"